/*
 *
 * ReportAdmin actions
 *
 */

import {
  GET_LIST_RANKS_WATCHER,
  GET_LIST_RANKS_SUCCESS,
  GET_LIST_RANKS_FAILED,
} from "./constants"

export function getListRanksWatcher(payload) {
  return {
    type: GET_LIST_RANKS_WATCHER,
    payload,
  }
}

export function getListRanksSuccess(payload) {
  return {
    type: GET_LIST_RANKS_SUCCESS,
    payload,
  }
}

export function getListRanksFailed() {
  return { type: GET_LIST_RANKS_FAILED }
}
